<template>
  <div id="FinalisedTestsView" class="finalised-tests-view">
    <Header></Header>
    <b-container fluid>
      <b-row>
        <LeftNav></LeftNav>
        <b-col>
          <b-row>
            <TestsTabs isFinalised></TestsTabs>
          </b-row>
          <b-row class="justify-content-end mt-5 mb-3">
            <b-col sm="3">
              <b-form-input v-model="tableFilter" type="text" placeholder="Filter"></b-form-input>
            </b-col>
            <b-col sm="1">
              <a class="icon-container pointer" @click.prevent="refresh">
                <i class="material-icons text-muted" :class="{ rotating: isRefreshing }">refresh</i>
              </a>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="pl-sm-5">
              <b-table striped
                :items="tests"
                :fields="fields"
                :filter="tableFilter"
                @sort-changed="sortingChanged"
                :sort-compare="compareRows"
                :current-page="currentPage"
                :per-page="perPage"
                :sort-direction="sortDirection"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc">
                <template slot="name" slot-scope="data">
                  <router-link :to="{ name: 'testdetails', params: { id: data.item.id } }">{{data.item.name}}</router-link>
                </template>
                <template slot="countryId" slot-scope="data">
                  {{ getCountryById(data.item.countryId).name }}
                </template>
                <template slot="carrierpercentage" slot-scope="data">
                  {{ getCarrierById(data.item.carrierId).name }} ({{data.item.percentage}}%)
                </template>
                <template slot="start" slot-scope="data">
                  {{data.value | formatDate}}
                </template>
                <template slot="end" slot-scope="data">
                  {{data.value | formatDate}}
                </template>
                 <template slot="status" slot-scope="data">
                  <span :class="{'text-success': !data.item.status, 'text-danger': data.item.status}">{{data.item.status | toTestStatusString}}</span>
                </template>
              </b-table>
              <b-pagination v-if="isPaginationShown()" align="center" :total-rows="tests.length" :per-page="perPage" v-model="currentPage"></b-pagination>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { sortByDate, sortByCountry, sortByCarrier, sortByString } from '@/util/sorting'
import LeftNav from '@/components/layout/LeftNav.vue'
import Header from '@/components/layout/Header.vue'
import TestsTabs from '@/components/TestsTabs.vue'

export default {
  name: 'OngoingTest',
  components: {
    LeftNav,
    Header,
    TestsTabs
  },
  async created () {
    await this.loadCountries()
    await this.loadCarriers()
    await this.loadTests()
  },
  mounted () {
    if ('currentPage' in this.$route.params) {
      this.currentPage = parseInt(this.$route.params.currentPage)
    }
  },
  methods: {
    ...mapActions({
      'loadTests': 'tests/loadTests',
      'fetchTests': 'tests/fetchTests',
      'loadCarriers': 'tests/loadCarriers',
      'loadCountries': 'countries/loadCountries'
    }),
    compareRows (a, b) {
      if (this.sortBy === 'start') {
        return sortByDate(this.sortDesc, a.start, b.start)
      } else if (this.sortBy === 'end') {
        return sortByDate(this.sortDesc, a.end, b.end)
      } else if (this.sortBy === 'countryId') {
        return sortByCountry(this.sortDesc, a.countryId, b.countryId)
      } else if (this.sortBy === 'carrierpercentage') {
        return sortByCarrier(this.sortDesc, a.carrierId, b.carrierId)
      }

      return sortByString(this.sortBy, this.sortDesc, a, b)
    },
    sortingChanged (ctx) {
      this.sortBy = ctx.sortBy
      this.sortDesc = ctx.sortDesc
    },
    refresh () {
      this.isRefreshing = true
      this.fetchTests().then(() => {
        this.isRefreshing = false
      })
    },
    isPaginationShown () {
      return this.tests.length > this.perPage
    }
  },
  computed: {
    ...mapGetters({
      'tests': 'tests/finalisedTests',
      'getCarrierById': 'tests/getCarrierById',
      'getCountryById': 'countries/getCountryById'
    })
  },
  watch: {
    currentPage: {
      handler (newValue) {
        this.$router.push({name: 'finalisedtestswithpage', params: {'currentPage': newValue}})
      }
    }
  },
  data () {
    return {
      sortBy: 'end',
      sortDesc: true,
      sortDirection: 'asc',
      tableFilter: null,
      isRefreshing: false,
      perPage: 10,
      currentPage: 1,
      fields: [
        { key: 'select', label: '' },
        { key: 'name', label: 'Name', sortable: true },
        { key: 'countryId', label: 'Country', sortable: true },
        { key: 'breakout', label: 'Breakout', sortable: true },
        { key: 'carrierpercentage', label: 'Carrier', sortable: true },
        { key: 'start', label: 'Start Date', sortable: true },
        { key: 'end', label: 'End Date', sortable: true },
        { key: 'status', label: 'Test Status', sortable: true }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/tests/FinalisedTests.vue